(function(){
  'use strict';

  function disableMobilePopups(){
    if(document.getElementById('fh-disable-mobile-popups-css')) return;
    var style = document.createElement('style');
    style.id = 'fh-disable-mobile-popups-css';
    style.textContent = '@media (max-width:768px){.fh-lead-modal,.fh-email-popup,.newsletter-popup,.popup-modal[class*=newsletter],[class*=klaviyo][class*=popup],[class*=klaviyo][class*=modal]{display:none!important;visibility:hidden!important;opacity:0!important;pointer-events:none!important;}}';
    document.head.appendChild(style);
  }

  function injectPopupStyles(){
    if(document.getElementById('fh-popup-mobile-polish-css')) return;
    var style = document.createElement('style');
    style.id = 'fh-popup-mobile-polish-css';
    style.textContent = [
      '.fh-email-popup [class*=recommend],.fh-email-popup [class*=product],.fh-email-popup [class*=upsell],.fh-email-popup .fake-order,.fh-email-popup .product-list,.fh-email-popup .mini-cart,.fh-email-popup .cart-items{display:none!important;}',
      '.fh-email-popup button[type=submit],.fh-email-popup input[type=submit]{background:#090909!important;color:#fff!important;border:0!important;font-weight:950!important;text-transform:uppercase!important;letter-spacing:.04em!important;}',
      '@media (max-width:768px){.fh-lead-modal{padding:10px!important;place-items:end center!important;background:rgba(0,0,0,.58)!important;}.fh-lead-card,.fh-email-popup{width:min(430px,96vw)!important;max-height:76vh!important;overflow:auto!important;border-radius:18px 18px 0 0!important;display:block!important;}.fh-lead-image,.fh-email-popup img{max-height:150px!important;aspect-ratio:16/9!important;overflow:hidden!important;}.fh-lead-image img,.fh-email-popup img{width:100%!important;height:100%!important;object-fit:cover!important;}.fh-lead-copy,.fh-email-popup form{padding:18px!important;}.fh-lead-title,.fh-email-popup h2,.fh-email-popup .title{font-size:28px!important;line-height:1.05!important;margin-bottom:10px!important;}.fh-lead-copy p,.fh-email-popup p{font-size:14px!important;line-height:1.35!important;margin-bottom:12px!important;}.fh-lead-form{gap:9px!important;margin:12px 0!important;}.fh-lead-form input,.fh-lead-form button,.fh-email-popup input[type=email],.fh-email-popup button[type=submit],.fh-email-popup input[type=submit]{height:50px!important;min-height:50px!important;width:100%!important;font-size:15px!important;}.fh-lead-pills{gap:6px!important;}.fh-lead-pills li{font-size:11px!important;padding:7px 9px!important;}.fh-lead-close{right:10px!important;top:10px!important;width:36px!important;height:36px!important;font-size:24px!important;}}'
    ].join('\n');
    document.head.appendChild(style);
  }

  function optimizeEmailPopups(){
    var emailInputs = document.querySelectorAll('input[type="email"], input[name*="email" i]');
    for(var i=0;i<emailInputs.length;i++){
      var input = emailInputs[i];
      var popup = input.closest('.fh-lead-card,.newsletter-popup,.popup,.popup-modal,[class*="newsletter"][class*="popup"],[class*="Popup"],[id*="Popup"],.modal');
      if(!popup || !popup.querySelector('input[type="email"], input[name*="email" i]')) continue;
      popup.classList.add('fh-email-popup');
      var buttons = popup.querySelectorAll('button[type="submit"], input[type="submit"], form button');
      for(var b=0;b<buttons.length;b++){
        if(buttons[b].tagName === 'INPUT') buttons[b].value = 'Send Code';
        else buttons[b].textContent = 'Send Code';
      }
    }
  }

  function injectMobileHeroPolish(){
    if(document.getElementById('fh-mobile-hero-short-copy-css')) return;
    var style = document.createElement('style');
    style.id = 'fh-mobile-hero-short-copy-css';
    style.textContent = [
      '@media (max-width:990px){',
      '.fh-home .fh-hero{min-height:620px!important;background:#050505!important;}',
      '.fh-home .fh-hero__slider{inset:0 0 auto 0!important;height:min(100vw,420px)!important;background:#050505!important;overflow:hidden!important;}',
      '.fh-home .fh-hero__slide{display:none!important;opacity:0!important;visibility:hidden!important;transform:none!important;transition:none!important;}',
      '.fh-home .fh-hero__slide:first-child{display:block!important;opacity:1!important;visibility:visible!important;}',
      '.fh-home .fh-hero__slide:first-child img{width:100%!important;height:100%!important;object-fit:contain!important;object-position:center center!important;background:#050505!important;}',
      '.fh-home .fh-hero__shade{background:linear-gradient(180deg,rgba(0,0,0,0) 0%,rgba(0,0,0,0) 55%,rgba(5,5,5,.9) 100%)!important;inset:0 0 auto 0!important;height:min(100vw,420px)!important;}',
      '.fh-home .fh-hero__wrap{padding-top:calc(min(100vw,420px) + 24px)!important;padding-bottom:26px!important;align-items:end!important;}',
      '.fh-home .fh-hero__panel{padding:0!important;}',
      '.fh-home .fh-hero__eyebrow{font-size:11px!important;letter-spacing:.2em!important;margin-bottom:12px!important;}',
      '.fh-home .fh-hero h1{font-size:clamp(38px,11vw,48px)!important;line-height:.92!important;margin-bottom:12px!important;max-width:92vw!important;}',
      '.fh-home .fh-hero p{font-size:15px!important;line-height:1.35!important;margin:12px 0 16px!important;max-width:340px!important;}',
      '.fh-home .fh-hero__search{margin-bottom:14px!important;}',
      '.fh-home .fh-hero__search input{padding:14px 16px!important;font-size:15px!important;}',
      '.fh-home .fh-hero__search button{min-height:46px!important;font-size:14px!important;}',
      '.fh-home .fh-hero__actions{gap:10px!important;margin-bottom:14px!important;}',
      '.fh-home .fh-hero__actions .fh-btn{min-height:42px!important;padding:0 14px!important;font-size:14px!important;}',
      '.fh-home .fh-rating{margin-top:0!important;font-size:12px!important;letter-spacing:.03em!important;gap:8px!important;white-space:nowrap!important;overflow:hidden!important;max-width:100%!important;}',
      '.fh-home .fh-stars{font-size:17px!important;}',
      '.fh-home .fh-hero__chips{display:none!important;}',
      '}',
      '@media (max-width:430px){.fh-home .fh-hero{min-height:590px!important}.fh-home .fh-hero__slider,.fh-home .fh-hero__shade{height:100vw!important}.fh-home .fh-hero__wrap{padding-top:calc(100vw + 22px)!important}}'
    ].join('');
    document.head.appendChild(style);
  }

  function isMobile(){
    return window.matchMedia && window.matchMedia('(max-width: 990px)').matches;
  }

  function forceMobileHeroSingle(){
    if(!isMobile()) return;
    var hero = document.querySelector('.fh-home .fh-hero');
    if(!hero) return;
    var slides = hero.querySelectorAll('[data-fh-hero-slide], .fh-hero__slide');
    for(var i=0;i<slides.length;i++){
      slides[i].classList.toggle('is-active', i===0);
      slides[i].style.display = i===0 ? 'block' : 'none';
      slides[i].style.opacity = i===0 ? '1' : '0';
      slides[i].style.visibility = i===0 ? 'visible' : 'hidden';
    }
    var firstImg = hero.querySelector('.fh-hero__slide:first-child img, [data-fh-hero-slide]:first-child img');
    if(firstImg){
      firstImg.src = 'https://cdn.shopify.com/s/files/1/0682/1271/9765/files/fahari-mobile-hero-flags-of-the-world.png?v=1787098534';
      firstImg.removeAttribute('srcset');
      firstImg.removeAttribute('sizes');
      firstImg.alt = 'Hands wearing Fahari flag bracelets in a circle';
      firstImg.style.objectFit = 'contain';
      firstImg.style.objectPosition = 'center center';
    }
  }

  function shortenMobileHeroCopy(){
    if(!isMobile()) return;
    var hero = document.querySelector('.fh-home .fh-hero');
    if(!hero) return;
    var eyebrow = hero.querySelector('.fh-hero__eyebrow, .fh-kicker');
    var heading = hero.querySelector('h1');
    var text = hero.querySelector('.fh-hero__panel > p:not(.fh-hero__eyebrow):not(.fh-kicker), .fh-hero__copy > p:not(.fh-kicker)');
    if(eyebrow) eyebrow.textContent = 'Pride you wear';
    if(heading) heading.textContent = 'Wear your roots.';
    if(text) text.textContent = 'Flag bracelets for your country, culture, and story.';
  }

  function init(){
    disableMobilePopups();
    injectPopupStyles();
    injectMobileHeroPolish();
    forceMobileHeroSingle();
    shortenMobileHeroCopy();
    optimizeEmailPopups();
    if(!window.matchMedia || !window.matchMedia('(max-width: 768px)').matches){
      setTimeout(optimizeEmailPopups, 800);
      setTimeout(optimizeEmailPopups, 2200);
    }
    setTimeout(function(){ forceMobileHeroSingle(); shortenMobileHeroCopy(); }, 250);
    setTimeout(function(){ forceMobileHeroSingle(); shortenMobileHeroCopy(); }, 900);
    setInterval(forceMobileHeroSingle, 1500);
  }

  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
  window.addEventListener('load', init, {once:true});
  document.addEventListener('shopify:section:load', init);
})();